import { Breakpoint } from 'types/utils';
import { StickyPanelProps } from '../sticky-panel';

export function getDisplayValue({ breakpoint }: { breakpoint: Breakpoint }): StickyPanelProps['display'] {
  return breakpoint === 'mobile' ? 'none' : 'only-navigation';
}
